import { ALL_AGENTS, type AgentOption } from '@losan/core';

interface Props {
  agents: AgentOption[];
  value: string;           // current viewAgentId ('__all__' or an agent id)
  onChange: (agentId: string) => void;
}

/**
 * Admin-only agent filter. Lets the administrator switch between the aggregated
 * "all agents" view and any single agent. Not rendered for regular agents (they
 * only ever see their own data).
 */
export function AgentFilter({ agents, value, onChange }: Props) {
  return (
    <label className="filter-dropdown agent-filter">
      <span>Agente</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value={ALL_AGENTS}>Todos los agentes</option>
        {agents.map((a) => (
          <option key={a.id} value={a.id}>
            {a.name} ({a.id})
          </option>
        ))}
      </select>
    </label>
  );
}
